<template>
  <div id="places_app">
    <div class="container-fluid px-0">
      <div class="row no-gutters">
        <div class="col-lg-4 col-md-5 col-sm-5 col-xl-3 sidebar bg-dark-nvx">
          <div class="sidebar-sticky accordion">

            <div class="d-flex justify-content-center flex-wrap flex-md-nowrap align-items-center p-2">

              <div class="btn-toolbar" role="toolbar">
                <div class="btn-group mr-2" role="group" aria-label="actions">
                  <router-link class="btn btn-primary btn-sm" to="/user/places/import/">{{$t('import_places')}}
                  </router-link>
                  <button class="btn btn-sm btn-primary" v-on:click="add_place">{{$t('add_a_place')}}</button>
                </div>
                <div class="btn-group mr-2" role="group" aria-label="delete" v-show="places.length">
                  <button class="btn btn-sm btn-danger" @click="on_delete_modal"><span data-feather="trash"></span></button>
                </div>
              </div>

            </div>

          <li class="nav-item border-bottom" style="border-color: #333 !important;">
            <div class="nav-link" v-on:click="select_all()"
                 v-bind:class="{'active': (selected==null) }">{{$t('all_places')}} ({{places.length}})
            </div>
          </li>
          <li v-for="place in places" :key="place.id" class="nav-item">
            <div class="nav-link" v-bind:class="{'active': (selected&&selected.id==place.id) }"
                 v-on:click="select(place)">
              <img v-show="(!edit||!selected||selected.id!=place.id)"
                   class="mr-2" width=24 height=24
                   v-bind:src="'/js/gmaps/white/'+ place_icon(place)"
                   v-bind:alt="place.type">
              <span v-show="(!edit||!selected||selected.id!=place.id)"
                    v-text="format_place_name(place)"></span>

              <span class="nav-link-auto" v-if="place.automatic" style="font-size: .8rem;">Auto</span>
              <span v-show="!edit&&place.require_save">
                                    <span data-feather="alert-circle"></span>
                                </span>
              <div class="btn-group float-right" v-show="(selected&&selected.id==place.id)">
                <button class="btn btn-sm btn-primary" v-on:click="toggle_edit_mode">
                  {{$t('edit')}}
                </button>
              </div>
            </div>
            <div id="editInterface" v-show="edit&&selected&&selected.id==place.id">
              <div>
                <input type="text" class="form-control" v-model="place.name"
                       v-on:input="changeName(place)" autofocus>
              </div>
              <div class="my-2">
                {{$t('adress')}}
                <input class="form-control" type="text" :id="'address' + place.id"
                       ref="place_address"
                       v-model="address"/>
              </div>
              <h6>Type</h6>
              <multiselect
                  v-model="place.type"
                  :options="place_types"
                  :multiple="false"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :allowEmpty="false"
                  :select-label="$t('select')"
                  :selected-label="$t('selected')"
                  :deselect-label="$t('deselect_label')">
              </multiselect>

              <h6>{{$t('devices_using_the_place')}}</h6>
              <multiselect
                  v-model="place.devices"
                  :options="devices_ids"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :hide-selected="true"
                  :preserve-search="true"
                  :placeholder="$t('enable_device_for_the_place')"
                  :select-label="$t('select')"
                  :selected-label="$t('selected')"
                  :deselect-label="$t('deselect_label')"
                  :custom-label="device_label">
              </multiselect>
              <div class="row mx-2 mb-2">
                <button v-if="place.id" class="btn btn-success" v-on:click="save(place)">
                  {{$t('Save')}}
                </button>
                <button v-if="!place.id" class="btn btn-success" v-on:click="save(place)">
                  {{$t('create')}}
                </button>
                <button v-if="place.id" class="btn btn-danger" v-on:click="will_delete(place)">
                  {{$t('delete')}}
                </button>
              </div>
            </div>
          </li>
        </div>
      </div>

      <div role="main" class="col-sm-7 col-md-7 ml-sm-auto col-lg-8  col-xl-9 mx-0">
        <div id="map_container">
          <div id='map'></div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="place_to_delete&&selected">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{$t('delete_place')}}
                  <span v-if="selected" v-text="selected.name"></span>
                </h4>
              </div>
              <div class="modal-body">
                <div>
                  {{$t('delete_condition')}}
                  <br>
                  <h5>{{$t('delete_definitive')}}</h5>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" v-on:click="will_cancel(place)">
                  {{$t('cancel')}}
                </button>
                <button id='delete-btn' class="btn btn-danger" v-on:click="on_delete(selected)">
                  {{$t('delete')}}
                </button>
              </div>
            </div><!-- /.modal-content -->
          </div><!-- /.modal-dialog -->
        </div>
      </div>
    </transition>
  </div>

    <div v-if="show_delete_modal">
      <transition name="modal2">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{{$t('delete_all_places')}}</h4>
                </div>
                <div class="modal-body">
                  <div>
                    {{$t('delete_condition')}}
                    <br>
                    <input type="checkbox" id="checkbox" v-model="automatic_delete_filter">
                    <label for="checkbox">{{$t('delete_automatic_places_only')}}</label>
                    <h5>{{$t('delete_definitive')}}</h5>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" @click="will_cancel">
                    {{$t('cancel')}}
                  </button>
                  <button id='delete-btn' class="btn btn-danger" v-on:click="on_delete_all">
                    {{$t('delete')}}
                  </button>
                </div>
              </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
          </div>
        </div>
      </transition>
    </div>

  </div>
</template>

<style>

#more::after {
  display: none
}

#editInterface {
  color: white;
  background: #4C4C4C;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>

import {clearPlaces} from "../nvxcommon";

function place_icon_type(place) {

  var icon = "place.png"
  if (place.type == "warehouse") {
    icon = "warehouse.png";
  } else if (place.type == "store") {
    icon = "store.png";
  } else if (place.type == "home") {
    icon = "home.png";
  } else if (place.type == "work") {
    icon = "work.png";
  } else if (place.type == "school") {
    icon = "school.png";
  }

  return icon
}

function place_name(place) {
  if (place.name.length) {
    return place.name;
  }

  return window.app.$t('Place')
}


var map = null;
var markers = [];
var markerCluster = null;
var infoWindow = null;


// Removes the markers from the map, but keeps them in the array.
function clearPlacesMarkers() {
  if (markerCluster) {
    markerCluster.clearMarkers();
    markerCluster = null;
  }
  for (let i = 0; i < markers.length; i++) {
    markers[i].setMap(null);
  }
  markers = [];
}

function resizeMap(map, places) {
  var bounds = new google.maps.LatLngBounds();
  var coordinates = [];

  for (var i = 0; i < places.length; i++) {
    var place = places[i];
    var point = {lat: place.lat, lng: place.lng};
    bounds.extend(point);
    coordinates.push(point)
  }
  google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
    this.setZoom(Math.min(15, this.getZoom()));
  });
  map.fitBounds(bounds)
}


import {HTTP} from '../http-constants'
import Multiselect from 'vue-multiselect'
import * as nvxlib from '../nvxcommon'
import gmapsInit from "@/gmaps"
import { MarkerClusterer, DefaultRenderer} from "@googlemaps/markerclusterer";

import "../assets/ith_style.css"
import "../assets/scss/style.scss"


const feather = require('feather-icons')
export default {
  name: "Places",
  components: {
    multiselect: Multiselect,
  },
  delimiters: ['${', '}'],
  data() {
    return {
      selected: null,
      places: [],
      place_to_delete: false,
      place_types: [],
      edit: false,
      devices: [],
      devices_ids: [],
      address: null,
      autocompletes: [],
      show_delete_modal: false,
      automatic_delete_filter: true
    }
  },
  methods: {
    'initMap': function () {
      let self = this;
      map = new google.maps.Map(document.getElementById('map'), {
        zoom: 10,
        scaleControl: true,
        streetViewControl: true,
      });

      clearPlacesMarkers();
      self.setMarkers(map, self.places, true);
    },
    'setMarkers': function (map, places, resize) {
      var self = this;

      for (var i = 0; i < places.length; i++) {
        var place = places[i];
        var icon = {
          url: "/js/gmaps/" + place_icon_type(place),
          scaledSize: new google.maps.Size(20, 20),
          labelOrigin: new google.maps.Point(10, 26)
        };

        var label = {
          text: place_name(place),
          fontSize: '14px',
          color: 'black',
        }

        var marker = new google.maps.Marker({
          position: {lat: place.lat, lng: place.lng},
          map: map,
          title: place.name,
          label: label,
          icon: icon,
          nvx_place: place,
        });
        markers.push(marker)

        google.maps.event.addListener(marker, 'click', (function (marker, self) {
          return function () {
            let place = marker.nvx_place;
            let _title = "<b>" + place.name + "</b><br>";
            if (place.devices.length) {
              _title += app.$t("Trackers") + ": " + place.devices.length + "<br>"
            }
            if (infoWindow) {
              infoWindow.close()
            }
            infoWindow = new google.maps.InfoWindow();
            infoWindow.setContent(_title);
            infoWindow.open(map, marker);

            self.selected = place;

          }
        })(marker, self), {passive: true});
      }

      if (resize) {
        resizeMap(map, places)
      }
      const mcOptions = {
        gridSize: 70,
        maxZoom: 13,
        map: map,
        render: new DefaultRenderer({}),
        markers: markers
      };
      markerCluster = new MarkerClusterer(mcOptions);
    },
    'load_places': function () {
      var self = this;
      nvxlib.getPlaces(function (places) {
          self.places = places;
          self.place_types = ['other', 'school', 'work', 'home', 'unknown', 'store'];
          self.initMap();
      });

    },
    'select_all': function () {
      this.selected = null;
      this.edit = false;
      var _places = this.places;
      clearPlacesMarkers();
      this.setMarkers(map, _places, true);
    },
    'select': function (place) {
      if (this.selected && this.selected.id != place.id) {
        this.edit = false;
      }
      this.selected = place;
      map.setCenter({lat: place.lat, lng: place.lng});
      map.setZoom(15);
      this.configure_map_edit()
    },
    'toggle_edit_mode': function () {
      var new_value = !this.edit;
      this.edit_mode(new_value);
    },
    'edit_mode': function (enable) {
      this.edit = enable;
      if (this.edit) {
        if (this.selected) {
          var _places = [this.selected];
          this.resolve_place_address();
          clearPlacesMarkers();
          this.setMarkers(map, _places, true);
          this.init_autocomplete();
        }
      } else {
        let _places = this.places;
        clearPlacesMarkers();
        this.setMarkers(map, _places, true);
      }
    },
    'movePlace': function (position) {
      this.selected.lat = position.lat();
      this.selected.lng = position.lng();

      var marker = markers[0];
      marker.setPosition(position);
      resizeMap(map, [this.selected]);
    },
    'load_devices': function () {
      var self = this;
      nvxlib.getDevices(function (devices) {
        if (devices.length) {
          self.devices = devices;
          self.devices_ids = self.devices.map(a => a.id);
        }
      });
    },
    'place_icon': function (place) {
      return place_icon_type(place);
    },
    'will_delete': function (place) {
      this.place_to_delete = true;
    },
    'on_delete_modal': function(){
      this.selected = null;
      this.automatic_delete_filter = true;
      this.show_delete_modal = true
    },
    'will_cancel': function (place) {
      this.place_to_delete = false;
      this.show_delete_modal = false
    },
    'on_delete_all': function (auto) {
      let self = this;
      self.show_delete_modal = false;
      let arg = self.automatic_delete_filter?"True":"False";
      HTTP.delete("/tracker_places/?auto=" + arg)
          .then(function (re) {
            nvxlib.clearPlaces();
            self.load_places();
          })
          .catch(function (error) {
            console.log(error);
          })
    },
    'on_delete': function (place) {
      var self = this;
      self.place_to_delete = false
      HTTP.delete("/tracker_places/" + place.id + "/", place)
          .then(function (re) {
            var idx = self.places.indexOf(place);
            if (idx >= 0) {
              if (place == self.selected) {
                self.selected = null;
              }
              self.places.splice(idx, 1);
              nvxlib.savePlaces(self.places);
              clearPlacesMarkers();
              self.setMarkers(map, self.places, true);
            }
          })
          .catch(function (error) {
            console.log(error);
          })
    },
    'changeName': function (place) {
      var marker = markers[0];
      var label = marker.label;

      label.text = place_name(place);
      marker.setLabel(label);
    },
    'save': function (place) {
      var self = this;
      if (!place.id) {
        HTTP.post('/tracker_places/', place)
            .then(function (re) {
              if (re.status == '204') {
                self.places.pop();
              } else {
                var idx = self.places.indexOf(place);
                if (idx >= 0) {
                  self.places[idx] = re.data;
                  self.selected = self.places[idx];
                  nvxlib.savePlaces(self.places);
                }
              }
              self.edit_mode(false);
            })
            .catch(function (error) {
              console.log(error);
            });
      } else {
        place.automatic = false;
        HTTP.patch('/tracker_places/' + place.id + '/', place)
            .then(function (re) {
              var idx = self.places.indexOf(place);
              if (idx >= 0) {
                self.places[idx] = re.data;
                self.selected = self.places[idx];
                nvxlib.savePlaces(self.places);
              }
              self.edit_mode(false);
            })
            .catch(function (error) {
              console.log(error);
            });
      }
    },
    'device_label': function (option) {
      var devices = this.devices.filter(a => a.id == option);
      if (devices.length) {
        return devices[0].name;
      }
      return `${option}`
    },
    'format_place_name': function (place) {
      return place_name(place);
    },
    'add_place': function () {
      var c = map.getCenter();

      var place = {
        id: null,
        lat: c.lat(),
        lng: c.lng(),
        type: 'other',
        name: app.$t('new_place'),
      };
      place.devices = [];
      place.require_save = true;
      var new_places = this.places.filter(elem => elem.id == null);
      if (new_places.length > 0) {
        place = new_places[0];
      } else {
        this.places.push(place);
        this.$forceUpdate();
      }
      this.select(place);
      this.edit_mode(false);
    },
    'on_select_device': function (device_id) {
      var self = this;
      HTTP.put('/devices/' + device_id + '/tracker_places/' + this.selected.id + '/',)
          .then(function (re) {
            var updated_place = re.data;
            var idx = self.places.findIndex(elem => elem.id == updated_place.id);
            if (idx >= 0) {
              self.places[idx] = updated_place;
              nvxlib.savePlaces(self.places);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    'on_remove_device': function (device_id) {
      var self = this;
      HTTP.delete('/devices/' + device_id + '/tracker_places/' + this.selected.id + '/',)
          .then(function (re) {
            var updated_place = re.data;
            var idx = self.tags.findIndex(elem => elem.id == updated_place.id);
            if (idx >= 0) {
              self.places[idx] = updated_place;
              nvxlib.savePlaces(self.places);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    'resolve_place_address': function () {
      var _place = this.selected;
      var point = new google.maps.LatLng(_place.lat, _place.lng);
      var geocoder = new google.maps.Geocoder();
      var self = this;
      console.log("resolve_address");
      geocoder.geocode({'location': point}, function (results, status) {

        if (status === 'OK') {
          if (results[0]) {
            self.address = results[0].formatted_address;
          } else {
            window.alert('No results found');
          }
        } else if (status == 'ZERO_RESULTS') {
          self.address = "?";
        } else {
          window.alert('Geocoder failed due to: ' + status);
        }
      });
    },
    'configure_map_edit': function () {
      if (this.edit) {
        var marker = markers[0];

        marker.setDraggable(true);
        var self = this;
        google.maps.event.addListener(marker, 'dragend', function (event) {
          if (self.selected) {
            self.selected.lat = this.position.lat();
            self.selected.lng = this.position.lng();
            self.resolve_place_address();
          }
        });
      } else {
        for (var i = 0; i < markers.length; i++) {
          let marker = markers[i];
          marker.setDraggable(false);
        }
      }
    },
    'init_autocomplete': function () {
      var inputs = this.$refs.place_address;
      var options = {region: 'EU',};
      var self = this;

      this.autocompletes = [];
      inputs.forEach(function (elem) {
        var autocomplete = new google.maps.places.Autocomplete(elem, options);
        autocomplete.setFields(['geometry', 'icon', 'name', 'formatted_adress']);

        self.autocompletes.push(autocomplete);

        autocomplete.addListener('place_changed', function () {
          var place = autocomplete.getPlace();
          if (!place.geometry) {
            //window.alert("No details available for input: '" + place.name + "'");
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({'address': place.name, region: 'EU'}, function (results, status) {
              if (status === 'OK') {
                var location = results[0].geometry.location;
                self.address = results[0].formatted_address;
                self.movePlace(location);
              }
            });
            return
          }
          var location = place.geometry.location;
          self.address = place.formatted_address;
          self.movePlace(location);
        });
      });
    }
  },
  created: function () {
  },
  async mounted() {
    const google = await gmapsInit();
    this.load_devices();
    this.load_places();
  },
  updated: function () {
    feather.replace();
  },
}

</script>
